import { render, staticRenderFns } from "./EpieAulasLancadas.vue?vue&type=template&id=20473eca"
import script from "./EpieAulasLancadas.vue?vue&type=script&lang=js"
export * from "./EpieAulasLancadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports